import React, { useState, useEffect, useRef} from 'react';
import '../css/NotesArea.css';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/joy/List';
import ListDivider from '@mui/joy/ListDivider';
import ListItem from '@mui/joy/ListItem';
import DehazeSharpIcon from '@mui/icons-material/DehazeSharp';
import TransitionAlert from './TransitionAlert.js';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';


import parse from 'html-react-parser'

import {APIAddNote,APIGetNotes} from '../APIS/wupuapAPI.js'
import {getNowMySQL} from '../globals'

import { useSelector } from 'react-redux';

export default function NotesArea(props) {
    const [opennote, setOpenNote] = useState(false)
    const [notes, setNotes] = useState([])
    const [openalert, setOpenAlert] = useState(false) 
    const [alertmsg, setAlertMsg] = useState("")
    const [openaddnote,setOpenAdd] = useState(false)
    const [selnote,setSelNote]=useState(-1)
    const [error,setError] = useState("")
    const [previd,setPrevID] = useState(props.id)
    const auth = useSelector(state => state.auth)

    const noteTitleRef = useRef(null);
    const noteTextRef = useRef(null);

    useEffect(()=> { 
        async function LoadData() {
          if(props.id===previd) {
            return
          }
          setPrevID(props.id)
          try {
            setError("");
            const ret = await APIGetNotes({
              token: auth.token,
              ttp_lead_id: props.data.uid,
            })
            if(ret.status) {
              setNotes(ret.data)
            }
          }catch(err) {
            console.log(`Catch Error in useEffect: ${err.toString()}`,err)
            setNotes([])
            setError(`Error Retrieving Notes ${err.toString()}`)
          }
        }

        if(auth.token > "" && typeof props.data !== 'undefined' && props.data.id > ""  && props.id > "" ) {
          LoadData();
        }
    },[props.data, auth.token, props.data.id, props.data.uid, props.id, previd]);

    const handleCloseNote = () => { 
      setOpenNote(false) 
    }
  
    const handleShowNote = (id) => {
      setSelNote(id)
      setOpenNote(true)
    }

    const OpenAlert = (msg) => {
        setAlertMsg(msg)
        setOpenAlert(true)
        return;
    }

    const handleAddNote = async (e) => {
        //console.log(`id set to ${data._id}`)
        const notetitle = noteTitleRef?.current?.value;
        const note = noteTextRef?.current?.value;
    
        if(notetitle.trim()===""){
          OpenAlert(`Error You Must Enter a Note Title before you can Add a New Note.`)
          return;
        }
        if(note.trim()===""){
          OpenAlert(`Error You Must Enter some Note Text before you can Add a New Note.`)
          return 
        }
    
        const datetime_added = getNowMySQL();
        setNotes(prevNotes => [...prevNotes, {note, title: notetitle, added_by: auth.name, dateadded: datetime_added, datetime_added}])
        const ret = await APIAddNote({
            token: auth.token,
            company_id: props.data.company_id, 
            ttp_lead_id: props.data.uid,
            note:note,
            title: notetitle,
            added_by: auth.name,
            datetime_added
        })
    
        //console.log(ret)
        if(!ret.status) 
          OpenAlert(`Error adding note ${ret.err}`)
        else{
          noteTextRef.current.value = ""
          noteTitleRef.current.value = ""
          setOpenAdd(false)
        }
    }

    const cancelAddNote = () => {
        setOpenAdd(false)
          noteTextRef.current.value = ""
          noteTitleRef.current.value = ""
    }
    
    return (
        <React.Fragment>
            <Dialog 
                open={openaddnote}
                onClose={() => setOpenAdd(false)}
                PaperProps={{component: 'paper'}}
                sx={{width: '600px', marginLeft: 'auto', marginRight: 'auto'}}
                
                maxWidth="xl"
            >
                <DialogTitle>Add New Note</DialogTitle>
                <DialogContent>
                <TextField
                    label='Note Title'
                    id='notetitle'
                    name='notetitle'  
                    type='text'
                    placeholder='Enter Note Title'
                    inputRef={noteTitleRef}
                    variant="standard"
                    sx={{fontSize: '10pt', marginBottom:'15px', minwidth: '400px', width: '400px'}}
                    readOnly={false}
                /><br/>
                <TextareaAutosize multiline className='notes' id='notes' placeholder='Enter Notes Here' minRows={8} maxRows={20} rows={8} ref={noteTextRef} style={{width: '500px'}} />
                </DialogContent>
                <DialogActions>
                <Button onClick={cancelAddNote}>Cancel</Button>
                <Button size='sm' variat='outline' onClick={handleAddNote}>Add Note</Button>
                </DialogActions>
            </Dialog>
        {typeof notes !== 'undefined' && selnote >= 0 &&  selnote <= notes.length &&
            <Dialog 
                open={(opennote && selnote >= 0)}
                onClose={handleCloseNote}
                maxWidth='xl'
                PaperProps={{component: 'form'}}
            >
                <DialogTitle>Note Details</DialogTitle>
                <DialogContent>
                <DialogContentText >Created on: {`${new Date(notes[selnote].datetime_added??'').toLocaleString()}`} </DialogContentText>
                <DialogContentText >By: {`${notes[selnote].added_by??''}\r\n\n`}<br/></DialogContentText>
                <DialogContentText >Title: {`${notes[selnote].title??''}\r\n`}<br/></DialogContentText>
                <DialogContentText >{error}</DialogContentText>
                <div className='postitnote' >
                {parse((notes[selnote].note??'').replaceAll("\n","<br/>"))}
                </div>
                {/* <TextareaAutosize className='postitnote' maxRows={20} cols={200} rows={20} defaultValue={notes[selnote].note??''} readOnly={true} /> */}
                </DialogContent>
                <DialogActions>
                <Button onClick={handleCloseNote}>Close Note</Button>
                </DialogActions>
            </Dialog> 
        }
      {props.accordion && 
      <Accordion>
        <AccordionSummary
          expandIcon={<ArrowDownwardIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Note History</Typography>
        </AccordionSummary>
        <AccordionDetails> 
        <div className='notecontainer' style={{maxWidth: props.maxwidth??'1280px', width: props.width??'1280px'}}>
            <div className='notearea' >
                <List variant="outlined" className='notelist' key='notelist' >
                {notes.map( (noteitem,index) => {
                    return (<>
                    
                        <ListItem size='sm' key={`notes_${index}_${noteitem.note_id}`}>
                            <div key={`notedate_${index}_${noteitem.note_id}`} className='note_date'>{`${new Date(noteitem.datetime_added?noteitem.datetime_added:new Date()).toLocaleString()}`}</div>
                            <div key={`notetitle_${index}_${noteitem.note_id}`} className='note_title' >{`${noteitem.title.substring(0,20).replaceAll('\n',' ')}${noteitem.title.length > 20?"...":""}`}&nbsp;</div>
                            <div key={`notetext_${index}_${noteitem.note_id}`} className='note_text' >{`${noteitem.note.substring(0,125).replaceAll('\n',' ')}${noteitem.note.length > 125?"...":""}`}&nbsp;<br/>
                              <div key={`noteuser_${index}_${noteitem.note_id}`}className='note_user' >{`Created by: ${noteitem.added_by??""}`}</div><br/>
                            </div>
                            <div key={`noteclick_${index}_${noteitem.note_id}`} ><DehazeSharpIcon onClick={() => {handleShowNote(index)}} /></div>
                        </ListItem> 
                        <ListDivider  key={`notedivider_${index}_${noteitem.note_id}`}  inset='gutter' />
                        </>
                    )             
                    })
                }
                </List>
            </div>
            <Button size='sm' variat='outline' onClick={() => setOpenAdd(true)}>Add A New Note</Button>
            <TransitionAlert open={openalert} Close={setOpenAlert} message={alertmsg} />
        </div>
      </AccordionDetails></Accordion> }

      {(!props.accordion || typeof props.accordion==='undefined') && 
        <div className='notecontainer' style={{maxWidth: props.maxwidth??'1280px', width: props.width??'1280px', height: '100%'}}>
            <div className='notearea' style={{height: '100%'}}>
                <List variant="outlined" className='notelist' key='notelist' style={{height: '100%'}} sx={{height: '100%'}}>
                {notes.map( (noteitem,index) => {
                    return (<>
                        <ListItem size='sm' key={`notes_${index}`}>
                            <div  key={`notedate_${index}_${noteitem.note_id}`} className='note_date'>{`${new Date(noteitem.datetime_added?noteitem.datetime_added:new Date()).toLocaleString()}`}</div>
                            <div  key={`notetitle_${index}_${noteitem.note_id}`} className='note_title' >{`${noteitem.title.substring(0,20).replaceAll('\n',' ')}${noteitem.title.length > 20?"...":""}`}&nbsp;</div>
                            <div  key={`notetext_${index}_${noteitem.note_id}`} className='note_text' >{`${noteitem.note.substring(0,125).replaceAll('\n',' ')}${noteitem.note.length > 125?"...":""}`}&nbsp;<br/>
                            <div  key={`noteuser_${index}_${noteitem.note_id}`} className='note_user' >{`Created by: ${noteitem.added_by??""}`}</div><br/>
                            </div>
                            <div key={`noteclick_${index}_${noteitem.note_id}`}  ><DehazeSharpIcon onClick={() => {handleShowNote(index)}} /></div>
                        </ListItem> 
                        <ListDivider  key={`notedivider_${index}_${noteitem.note_id}`}  inset='gutter' />
                        </>
                    )             
                    })
                }
                </List>
            </div>
            <Button size='sm' variat='outline' onClick={() => setOpenAdd(true)}>Add A New Note</Button>
            <TransitionAlert open={openalert} Close={setOpenAlert} message={alertmsg} />
        </div>
      }

    </React.Fragment>

    )
}